export default `float de ( vec3 p ) {
    float scene = 100.;
    float t = 1000; 
    float falloff = 1.0;
    for ( float index = 0.; index < 8.; ++index ) {
      p.xz *= rot( t / falloff );
      p = abs( p ) - 0.5 * falloff;
      scene = min( scene, max( p.x, max( p.y, p.z ) ) );
      falloff /= 1.8;
    }
    return -scene;
  }`